import {Observable} from 'rxjs';
import {APIResponse} from '@core/interfaces/system/system-common';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {DownloadURL, PeriodFilter, SimpleSeriesOld} from './load-forecast';

export abstract class SystemLoadForecastService {
    /*
     * Infrastructure: results for system
     */

    // System pages
    abstract getSystemForecastBySeasons(
        workflowItemId: number,
        scenarioId: string,
        period: PeriodFilter,
        subsystemId: string,
        unit: string,
        sensitivityId: string,
    ): Observable<SimpleSeriesOld[]>;

    abstract getSystemForecastBreakdown(
        workflowItemId: number,
        scenarioId: string,
        period: PeriodFilter,
        subsystemId: string,
        seasonIds: string[],
        unit: string,
        sensitivityId: string,
    ): Observable<DataSource>;

    abstract getSystemForecastBreakdownCSV(
        workflowItemId: number,
        scenarioId: string,
        period: PeriodFilter,
        subsystemId: string,
        seasonIds: string[],
        unit: string,
        sensitivityId: string,
    ): Observable<APIResponse<DownloadURL>>;

    abstract getSystemViolationsByInfrastructureType(
        workflowItemId: number,
        scenarioId: string,
        seasonTiming: string,
        period: PeriodFilter,
        viewBy: string,
        unit: string,
        sensitivityId: string,
    ): Observable<SimpleSeriesOld>;

    abstract getSystemViolationsPivot(
        workflowItemId: number,
        scenarioId: string,
        seasonTiming: string,
        period: PeriodFilter,
        unit: string,
        sensitivityId: string,
    ): Observable<DataSource>;

    abstract getSystemViolationsPivotCSV(
        workflowItemId: number,
        scenarioId: string,
        seasonTiming: string,
        period: PeriodFilter,
        unit: string,
        sensitivityId: string,
    ): Observable<APIResponse<DownloadURL>>;

    abstract getSystemViolationBreakdown(
        workflowItemId: number,
        scenarioId: string,
        period: PeriodFilter,
        viewBy: string,
        unit: string,
        sensitivityId: string,
    ): Observable<SimpleSeriesOld[]>;

    abstract getSystemViolationBreakdownPivot(
        workflowItemId: number,
        scenarioId: string,
        period: PeriodFilter,
        viewBy: string,
        unit: string,
        sensitivityId: string,
    ): Observable<DataSource>;

    abstract getSystemViolationBreakdownPivotCSV(
        workflowItemId: number,
        scenarioId: string,
        period: PeriodFilter,
        viewBy: string,
        unit: string,
        sensitivityId: string,
    ): Observable<APIResponse<DownloadURL>>;

    // Meta-analysis pages
    abstract getSystemForecastByFactors(
        workflowItemId: number,
        scenarioId: string,
        period: PeriodFilter,
        subsystemId: string,
        seasonIds: string[],
        unit: string,
        sensitivityId: string,
    ): Observable<SimpleSeriesOld[]>;

    abstract getSystemForecastPivot(
        workflowItemId: number,
        scenarioId: string,
        period: PeriodFilter,
        subsystemId: string,
        seasonIds: string[],
        unit: string,
        sensitivityId: string,
    ): Observable<DataSource>;

    abstract getSystemForecastPivotCSV(
        workflowItemId: number,
        scenarioId: string,
        period: PeriodFilter,
        subsystemId: string,
        seasonIds: string[],
        unit: string,
        sensitivityId: string,
    ): Observable<APIResponse<DownloadURL>>;
}
